import type { FrontendFeature } from '@backstage/frontend-plugin-api';
import apisModule from './apis';
import { entityPageFeatures } from './modules/entityPage';
import navModule from './modules/nav';
import { pageModules } from './modules/pages';
import { scaffolderFieldsModule } from './modules/scaffolder';
import signInPageModule from './modules/signInPage';
import themesModule from './modules/themes';

/**
 * Features installed explicitly. Every other plugin listed in
 * `packages/app/package.json` is installed by feature discovery
 * (`app.packages: all` in app-config.yaml).
 */
export const appFeatures: FrontendFeature[] = [
  themesModule,
  signInPageModule,
  navModule,
  apisModule,
  ...pageModules,
  scaffolderFieldsModule,
  ...entityPageFeatures,
];
